(() => {
  'use strict';
  if (window.URBSearch) return;

  const SOCK_QUERY = 'title:meia OR product_type:meia';
  const normalize = (term) => String(term || '').trim().toLocaleLowerCase('pt-BR');
  const isSocks = (term) => ['meia', 'meias', normalize(SOCK_QUERY)].includes(normalize(term));
  const queryFor = (term, type = '') => {
    if (type && !type.split(',').includes('product')) return term;
    return isSocks(term) ? SOCK_QUERY : term;
  };
  const searchPath = new URL(window.URB?.routes?.search || '/search', window.location.origin).pathname;
  const normalizeUrl = (rawUrl) => {
    const url = new URL(rawUrl, window.location.origin);
    if (url.origin !== window.location.origin || url.pathname !== searchPath) return url;
    const term = url.searchParams.get('q');
    if (term !== null) {
      const query = queryFor(term, url.searchParams.get('type') || '');
      if (query !== term) url.searchParams.set('q', query);
    }
    return url;
  };

  window.URBSearch = {
    queryFor,
    normalizeUrl,
    filterPredictive: (resources, term) => {
      if (!isSocks(term) || !Array.isArray(resources.products)) return resources;
      // The suggestion service can expand matches even when fields are limited.
      // Narrow only this explicit product intent; keep content suggestions intact.
      return {
        ...resources,
        products: resources.products.filter((product) => /\bmeias?\b/.test(
          normalize(`${product.title || ''} ${product.product_type || product.type || ''}`)
        ))
      };
    },
    predictiveTerm: (term) => isSocks(term) ? 'meia' : term,
    predictiveFields: (term) => isSocks(term)
      ? 'title,product_type'
      : 'title,product_type,variants.title,variants.sku,vendor,tag'
  };

  document.addEventListener('formdata', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const action = new URL(form.action, window.location.origin);
    if (action.origin !== window.location.origin || action.pathname !== searchPath) return;
    const term = event.formData.get('q');
    if (typeof term === 'string') {
      event.formData.set('q', queryFor(term, String(event.formData.get('type') || '')));
    }
  });

  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('a[href]');
    if (!link) return;
    const normalized = normalizeUrl(link.href);
    if (normalized.href !== link.href) link.href = normalized.href;
  });

  const current = normalizeUrl(window.location.href);
  if (current.href !== window.location.href) window.location.replace(current.href);
})();
